import * as types from '../../types'
import Immutable from 'immutable'
import diff from 'immutablediff'
import patch from 'immutablepatch'

const INITIAL_STATE = Immutable.fromJS({
    saving: false,
    filter: '',
    modalCreate: {
        show: false,
        data: null
    },
    modalCreateTipoProducto: {
        show: false,
        data: null
    },
})

export default function (state = INITIAL_STATE, action) {
    let temp
    switch (action.type) {
        case types.TIPOSERVICIOS_REINICIAR_ESTADO:
            return INITIAL_STATE
        case types.TIPOSERVICIOS_GUARDANDO:
            state = state.set('saving', action.payload)
            return state
        case types.TIPOSERVICIOS_MOSTRAR_OCULTAR_MODAL_CREATE:
            state = state.setIn(['modalCreate', 'show'], action.payload.show)
            if (action.payload.show) {
                state = state.setIn(['modalCreate', 'data'], Immutable.fromJS(action.payload.item))
            } else {
                state = state.set('modalCreate', INITIAL_STATE.get('modalCreate'))
            }
            return state
        case types.TIPOSERVICIOS_ACTUALIZAR_REGISTROS:
            temp = diff(state.getIn(`tiposervicios.data.${action.payload.id}`.split('.')), Immutable.fromJS(action.payload.item))
            state = state.setIn(`tiposervicios.data.${action.payload.id}`.split('.'), patch(state.getIn(`tiposervicios.data.${action.payload.id}`.split('.')), temp))
            return state

        case types.TIPOSERVICIOS_MOSTRAR_OCULTAR_MODAL_CREATE_TIPOPRODUCTO:
            state = state.setIn(['modalCreateTipoProducto', 'show'], action.payload.show)
            if (action.payload.show) {
                state = state.setIn(['modalCreateTipoProducto', 'data'], Immutable.fromJS(action.payload.item))
            } else {
                state = state.set('modalCreateTipoProducto', INITIAL_STATE.get('modalCreateTipoProducto'))
            }
            return state
        case types.TIPOSERVICIOS_ACTUALIZAR_TIPOSPRODUCTO:
            state = state.setIn(`modalCreate.data.tables.tipos_producto.data.${action.payload.id3n71f13r}`.split('.'), Immutable.fromJS(action.payload))
            return state

        case types.TIPOSERVICIOS_ACTUALIZAR_TABLA_USUARIOS_MODAL_CREATE_TIPOPRODUCTO:
            state = state.setIn(`modalCreateTipoProducto.data.tables.users.ids`.split('.'), Immutable.fromJS(action.payload))
            return state

        default:
            return state
    }
}